export const projectCommonMxins = {
  methods: {
    goToIndex () {
      this.$router.push({ name: 'project-index' })
    }
  }
}
